<template>
  <div>
  	<div class="input-wrap">
  		<label>标题</label>
      <el-input v-model="info.title" placeholder="请输入标题" class="title-input"></el-input>
    </div>
    <div>
    	<label class="detail-label">图文详情</label>
    	<Quill
        class="dk-li"
        v-model="info.content"/>
    </div>
    <div class="btn-wrap">
			<el-button type="primary" class="confirmBtn" @click="confirmClick">确认</el-button>
			<el-button @click="cancelClick">取消</el-button>
		</div>
  </div>
</template>

<script>
import Quill from '@/components/quill-editor';
import { addMessagePushList } from '@/api/content-manage';

export default {
  name: 'messagepush',
  data() {
  	return {
  		info: {
	      title: '',
	      content: ''
	    }
  	}
  },
  components: {
  	Quill,
  },
  methods: {
  	async confirmClick() {
  		if (!this.info.title || !this.info.content) {
  			this.$message('标题和详情不能为空')
  			return;
  		}
  		const { status } = await addMessagePushList(this.info);
  		if ( status !== 200 ) return
  		this.$router.go(-1);
  	},
  	cancelClick() {
      this.$router.go(-1);
  	}
  }
}
</script>

<style lang="less" scoped>
.title-input {
	display: block;
	width: 500px;
	margin-top: 20px;
	margin-bottom: 30px;
}
.detail-label {
	display: inline-block;
	margin-bottom: 20px;
}
.btn-wrap {
	text-align: center;
	padding-top: 30px;
	padding-bottom: 30px;
	.confirmBtn {
		margin-right: 50px;
	}
}
</style>
